export function getApiBaseUrl() {
  const hostname = window.location.hostname;
  /**
   * !!!! UNCOMMENT THE CODE BELOW FOR LOCAL TESTING !!!!
   */
  // Use the local environment variable to always set the correct base URL for local testing
  // if (process.env.REACT_APP_BASE_URL === 'beta') {
  //   return "https://beta.ratemymanager.fyi"; // For local testing, use the beta API
  // }

  // For production environment based on domain
  if (hostname.includes("beta")) {
    return "https://beta.ratemymanager.fyi";
  }
  return "https://ratemymanager.fyi"; // For production API
}
